import api from './api';

export interface MarketplaceAgent {
  id: string;
  agentCode: string;
  name: string;
  description: string;
  category?: string;
  subCategory?: string;
  iconUrl?: string;
  coverUrl?: string;
  developerName?: string;
  status?: string;
  version?: string;
  pricingMode?: string;
  capabilities?: {
    inputTypes?: string[];
    outputTypes?: string[];
    streaming?: boolean;
  };
  tags?: string[];
  loaded?: boolean;
  versions?: Array<{ id: string; version: string; status: string; changelog?: string }>;
}

export async function listMarketplaceAgents(params?: { category?: string; keyword?: string; loadedOnly?: boolean }) {
  const { data } = await api.get('/agents/marketplace', { params });
  return (Array.isArray(data) ? data : data?.items || []) as MarketplaceAgent[];
}

export async function loadMarketplaceAgent(agentCode: string) {
  const { data } = await api.post(`/agents/${agentCode}/load`, {});
  return data;
}

export async function unloadMarketplaceAgent(agentCode: string) {
  const { data } = await api.post(`/agents/${agentCode}/unload`, {});
  return data;
}
